import React, { Component } from "react";
import RouteManager from "../../managers/RouteManager";
import Utility, { deepClone } from "../../utility/Utility";
import {
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    DKIcons,
    DKLabel,
    DKIcon,
    DKSpinner,
    DKTooltipWrapper,
    DKInput,
    Toggle,
    INPUT_TYPE,
    showAlert
} from "deskera-ui-library";
import AttendanceSettingService from "./AttendanceSettingService";
import MapPopup from "./AttendanceMap";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME,COLUMN_CODE } from "../../managers/TableManger";
import EmployeePopup from "./EmployeePopup";
import { attendanceSettingGrid, parseColumnConfig, parseVisibleColumnConfig, updateRowAttendanceSetting } from "../configs/config";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import AttendanceSettingApiService from "../../services/AttendanceSettingApiService";
import { COMPANY_DATE_FORMATS } from "../../constants/Constant";
import i18next from "i18next";

import AddNewGeoFencingPopup from "./AddNewGeoFencingPopup";
import UserManager, { userPlanUpdate } from "../../managers/UserManager";
import CompanyDetailService from "../../services/CompanyDetailService";
import SegmentListContainer from "../list/SegmentListContainer";
import LocationMapping from "./LocationMapping";
import FeedbackPopup from "../common/FeedbackPopup";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export default class AttendanceSetting extends Component {

    gridContainer = React.createRef();
    isEmployeePopup = {
        visible: false,
        index: -1,
        data:null
    }
    isLocationPopup = {
        visible: false,
        index:-1,
        data:null
    }
    addNewGeoLocation = {
        visible:false
    }
     canValidate = false;
     attendanceData = {
        name: ""
    };
     grid
     dateFormat = ''
     plans = [];
     currentPlanName = "";
     isPlanLoaded= {
        userPlan:false,
        geoFencing:false
    }
    tabData = [
        {
            id:0,
            name: i18next.t("LOCATIONS")
        },{
            id:1,
            name: i18next.t("EMP_LOCATION_MAPPING")
        }
    ];
    geoLocations = []
    searchString = '';
    searchField = '';
    constructor(props) {
        super(props)
        this.state={
            isLocationEnable :TenantService.get(TENANT.GEO_LOCATION_ENABLE),
            isPROPlan: false,
            initialTabValue:0,
            needFeedbackPopup: false,
        }
        this.grid = {
            gridActions: {
                filters: [],
                currentPage: 1,
                totalPageCount: 1
            },
            gridData: {
                columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_ATTENDANCE_SETTING), TABLES.PEOPLE_ATTENDANCE_SETTING)),
                rowData: [],
                filter: [],
                originalData: []
            },
            canValidate: false
        }
        if (!Utility.isEmpty(UserManager.getUserPlanName())) {
            let plan = UserManager.getUserPlanDetails()
            if(!plan.InTrial && plan.TrialOver) {
                this.currentPlanName = UserManager.getUserPlanName();
            }

            this.isPlanLoaded = {
                ...this.isPlanLoaded,
                userPlan: true
            }
            this.checkValidPlanActivated()
        }
            userPlanUpdate.getPlan().subscribe(response => {
                if (response && response.plan?.PlanName ) {
                   if(!response.plan.InTrial && response.plan.TrialOver) {
                    this.currentPlanName = response.plan.PlanName;
                   }

                    this.isPlanLoaded = {
                        ...this.isPlanLoaded,
                        userPlan: true
                    }
                    this.checkValidPlanActivated()
                }
            })

        RouteManager.setPresenter(this);
        this.getPlans();
        
        document.addEventListener("click", this.onClickAttendanceSettingGrid) 
        this.tenantConfig()       
    }
    getPlans() {
        AttendanceSettingApiService.getPlanForGeoLocation().then(res=>{
            if(res && res.plans) {
                this.plans = res.plans;
                this.isPlanLoaded = {
                    ...this.isPlanLoaded,
                    geoFencing:true
                }
                this.checkValidPlanActivated()
            }
        },error=>{
            showToast(i18next.t("SOMETHING_WENT_WRONG"),TOAST_TYPE.FAILURE)
        })
    }
    checkValidPlanActivated() {
       if(!Utility.isEmpty(this.plans)) {

            this.setState({
                isPROPlan: this.plans.findIndex(p=> p?.toLowerCase() ==="professional") !== -1
            })
            if(this.state.initialTabValue === 1) {
                this.initial();
            }
       } else {
           this.updateState()
       }
    }
    initial() {
        this.grid = {
            gridActions: {
                filters: [],
                currentPage: 1,
                totalPageCount: 1
            },
            gridData: {
                columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_ATTENDANCE_SETTING), TABLES.PEOPLE_ATTENDANCE_SETTING)),
                rowData: [],
                filter: [],
                originalData: []
            },
            canValidate: false
        }
        let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))
        this.dateFormat = dateFormat[0]?.value;
        AttendanceSettingService.getUsers();
        this.getAttendanceData();
        this.getLocations()
    }
    onSearch(data) {
        this.searchField = 'name';
        this.searchString = data;
        this.getAttendanceData()
    }
    getAPIConfig( currentPage, searchString, searchField) {
        return {
            params: {
                currentPage: currentPage ,
                limit: 20,
                searchString: searchString,
                searchField: searchField
            },
            queryParams: this.getQueryParams( searchString,searchField)
        }
    }
    getQueryParams( searchString,searchField) {
        const queryParams = {}
        return queryParams;
    }
    getAttendanceData(){
        // showLoader()
        AttendanceSettingApiService.apiMappingConfig = this.getAPIConfig(this.grid.gridActions.currentPage ,this.searchString,this.searchField)
        AttendanceSettingApiService.getLocationMappingByPage().then(res=>{
            if(res && res['geolocations']) {

                this.grid.gridData.rowData = attendanceSettingGrid(res['geolocations'])
                this.grid.gridActions = {
                            ...this.grid.gridData.gridActions,
                            currentPage: res.filterConfig? parseInt(res.filterConfig.page):1,
                            totalPageCount: res.filterConfig? parseInt(res.filterConfig.totalPage):1
                        }
                this.updateState()
            }
        },error=>{
            showToast(i18next.t("UN_FETCH_REC"));
            console.log(error)
        })
    }
    getLocations() {
            AttendanceSettingApiService.getAttendanceSetting().then(res=>{
                if(res && res.geolocations) {
                    this.geoLocations = res.geolocations.filter(loc=>loc.active)
                    let locationIndex = this.grid.gridData.columnData.findIndex(col=>col.columnCode==="locations");
                    if(locationIndex != -1) {
                        this.grid.gridData.columnData[locationIndex].options = this.geoLocations.map(l=>{
                            return {
                                id:l.id,
                                name: l.name,
                                color:"bg-gray1 border-m"
                            }
                        })
                    }
                    this.updateState()
                }
            },error=>{

            })



    }
    onToggleChange() {
        if(!this.state.isLocationEnable) {
            this.initial()
        }
        let obj = TenantService.get(TENANT.CONFIG)
        obj = {
            ...obj,
            geofencing: !this.state.isLocationEnable
        }
        showLoader(
          `${
            obj.geofencing ? i18next.t("ENABLING") : i18next.t("DISABLING")
          } ${i18next.t("GEO_FENCING_SETTING")}... ${i18next.t("PLEASE_WAIT")}`
        );
        CompanyDetailService.updateTenantConfig(obj).then(res=>{
            CompanyDetailService.setGeoFencing(res["geofencing"]);
            // showToast(i18next.t("REC_UPDATE_SUCCESS"),TOAST_TYPE.SUCCESS);
            removeLoader();
            showToast(
              `${i18next.t("GEO_FENCING_ARE_NOW")} ${
                res["geofencing"] ? i18next.t("ENABLED") : i18next.t("DISABLED")
              }.`,
              TOAST_TYPE.SUCCESS
            );
        },error=>{
            removeLoader();
            showToast(i18next.t("REC_UPDATE_FAIL"),TOAST_TYPE.FAILURE);
        })
        this.setState({
            isLocationEnable: !this.state.isLocationEnable
        })

    }
    onRowUpdate = (data) => {
        let fieldIndex = data.rowData.invalidFields.findIndex(f=>f==data.columnKey);
        if(data.columnData.required && Utility.isEmpty(data.rowData[data.columnKey])) {
            if(fieldIndex == -1) {
                data.rowData.invalidFields.push(data.columnKey)
            }
        } else if(fieldIndex != -1) {
            data.rowData.invalidFields.splice(fieldIndex,1)
        }
        if(data.rowData.invalidFields && data.rowData.invalidFields.length==0) {
            let newRow = [data.rowData]
        let geoLocations = []
        newRow.forEach(obj=>{
            let newObj =  {
                id:obj.data.id,
                active: (obj.status[0] === "active") ? true:false,
                applicableToAll: obj.isApplicableToAll,
                locationIds:(obj.locations && data.columnKey==="locations")? obj.locations:((obj.data && !Utility.isEmpty(obj.data.locations))?obj.data.locations.map(loc=>loc.id):[]),
                iamUserIds:obj.employees ? obj.employees.map(e=>parseInt(e)):[]
            }
            geoLocations.push(newObj)
        })

        this.updateAttendanceRecord({geolocations:geoLocations});
        }
    }
    updateAttendanceRecord(param) {

        if(param) {
            AttendanceSettingApiService.saveMapping(param,true).then(res=>{
                showToast(i18next.t("REC_UPDATE_SUCCESS"),TOAST_TYPE.SUCCESS)
                this.getAttendanceData();
            },error=>{
                showToast(i18next.t("REC_UPDATE_FAIL"),TOAST_TYPE.FAILURE)
            })
        }
    }
    onRowDelete (data) {
        showAlert(
            `${i18next.t("DELETE_CONFIRMATION_TITLE")} ?`,
            i18next.t("DELETE_CONFIRMATION_MSG"),
            [
                {title: i18next.t("CANCEL"), className: "bg-gray1 border-m"},
                {title: i18next.t("DELETE"), className: "bg-red text-white ml-r", onClick: () => this.deleteAfterConfirmation(data)}
            ]
        );
    }
    deleteAfterConfirmation(data) {
        let obj = {
            ids:[]
        }
        if(data && data.rowData && data.rowData.data && data.rowData.data.id) {
            obj.ids.push(data.rowData.data.id)
        } else if(data && data.length >0) {
            data.forEach(d=>{
                if(d.data && d.data.id) {
                    obj.ids.push(d.data.id)
                }
            })
        }
        if(obj.ids && obj.ids.length != 0) {
            AttendanceSettingApiService.deleteGeoLocationMapping(obj).then(res=>{
                showToast(i18next.t("REC_DELETED"),TOAST_TYPE.SUCCESS);
                this.initial()
            },error=>{
                showToast(i18next.t("RED_FAIL_DELETE"),TOAST_TYPE.FAILURE);
            });
        }
    }
    onRowAdd() {
        this.addNewGeoLocation.visible = true;

        this.updateState()
    }
    updateGridRow(index,data,isLocation) {
        let obj = this.grid?.gridData?.rowData[index];
        if(obj) {
            if(data && !isLocation) {
                obj[COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.IS_APPLICABLE_TO_ALL] = data.isApplicableToAll ? true:false;
                obj['employees'] = data.isApplicableToAll ? [] : data.employeeName.map(u=>u.iamUserId)
                this.grid['gridData']['rowData'] = updateRowAttendanceSetting(this.grid?.gridData?.rowData,obj,index);
            } else if(isLocation) {
                obj['coordinatesList'] = data
                this.grid['gridData']['rowData']= updateRowAttendanceSetting(this.grid?.gridData?.rowData,obj,index);
            }
        }
    }
    getFieldValue(obj) {
        switch (obj.columnCode) {
            default:
                return this.attendanceData[obj.columnCode]
        }

    }
    checkIsValidGridData() {

        let cols = this.grid.gridData.columnData.filter(r=>r.required);
        let isValid = true;
        if(!this.state.isLocationEnable) {
            return true;
        }
        cols.forEach(col=>{
            if(col.required) {
                let rows = deepClone(this.grid.gridData.rowData);
                rows.forEach(row=>{
                    let fieldIndex = row.invalidFields.findIndex(f=>f==col.columnCode);
                    if(typeof row[col.columnCode] == 'string' && (Utility.isEmpty(row[col.columnCode]) || Utility.isEmpty(row[col.columnCode].trim()))) {
                        isValid = false
                        if(fieldIndex == -1) {
                            row['invalidFields'].push(col.columnCode)
                        }
                    } else if(Utility.isEmpty(row[col.columnCode]) && (row[col.columnCode]!=0) && col.type == INPUT_TYPE.NUMBER) {
                        isValid = false
                        if(fieldIndex == -1) {
                            row['invalidFields'].push(col.columnCode)
                        }
                    }
                    else if(Utility.isEmpty(row[col.columnCode]) && col.type !== INPUT_TYPE.NUMBER) {
                        isValid = false
                        if(fieldIndex == -1) {
                            row['invalidFields'].push(col.columnCode)
                        }
                    } else if(col.columnCode == COLUMN_CODE.PEOPLE_ATTENDANCE_SETTING.COORDINATES && row.coordinatesList?.length == 0) {
                        isValid = false
                        if(fieldIndex == -1) {
                            row['invalidFields'].push(col.columnCode)
                        }
                    }
                    if(isValid) {
                        row['invalidFields'] = []
                    }
                })
                this.grid.gridData = {
                    ...this.grid.gridData,
                    rowData:rows
                }
            }
        })
        return isValid;
    }
    prepareObjTOSubmit() {
        if(!this.checkIsValidGridData()) {
            showToast(i18next.t("PLEASE_FILL_FILED"),TOAST_TYPE.WARNING);
            this.updateState();
            return;
        }

        let newRow = this.grid.gridData.rowData.filter(d=>(!d.data || (Utility.isEmpty(d.data.id))));
        let geoLocations = []
        newRow.forEach(obj=>{
            let newObj =  {
                address:(obj.coordinatesList && obj.coordinatesList.length!=0 && obj.coordinatesList[0].address)?obj.coordinatesList[0].address:'',
                active: (obj.status[0] === "active") ? true:false,
                applicableToAll: obj.isApplicableToAll,
                latitude: (obj.coordinatesList && obj.coordinatesList.length!=0 && obj.coordinatesList[0].lat)?obj.coordinatesList[0].lat+"":'',
                longitude: (obj.coordinatesList && obj.coordinatesList.length!=0 && obj.coordinatesList[0].lng)?obj.coordinatesList[0].lng+"":'',
                name: (obj.name ? obj.name :(obj.locationName? obj.locationName:"")),

                radius:obj.radius,
                iamUserIds:obj.employees ? obj.employees.map(e=>parseInt(e)):[]
            }
            geoLocations.push(newObj)
        })

        return {geolocations:geoLocations};
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    componentDidMount() {
        this.setState({
            ...this.state
        })
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.onClickAttendanceSettingGrid)
    }

    onClickAttendanceSettingGrid = (e) => {
        if (e && e.srcElement.id && e.srcElement.id.includes("attendance_setting_emp_")) {
            let index = e.srcElement.id;


            index = index.substring(23, index.length);
            this.isEmployeePopup.data = {
                index:index,
                rowData: this.grid['gridData']['rowData'][index]
            }
            this.toggleVisibleEmp({ index: index });
            this.updateState()
        }
        if (e && e.srcElement.id && e.srcElement.id.includes("attendance_setting_location_")) {
            let index = e.srcElement.id;
            index = index.substring(28, index.length);
            this.isLocationPopup.data = {
                index:index,
                rowData: this.grid['gridData']['rowData'][index]
            }
            this.toggleVisibleMap({ index: index });
            this.updateState()
        }
    }
    toggleVisibleMap(data) {
        this.isLocationPopup.visible = !this.isLocationPopup.visible
        this.isLocationPopup.index = data ? data.index : null;
        this.isLocationPopup.data = this.isLocationPopup.visible ?  this.isLocationPopup.data:null
    }
    toggleVisibleEmp(data) {
        this.isEmployeePopup.visible = !this.isEmployeePopup.visible;
        this.isEmployeePopup.index = data ? data.index : null;
        this.isEmployeePopup.data = this.isEmployeePopup.visible ?  this.isEmployeePopup.data:null

    }
    onEmployeeClose(data) {
        if (this.isEmployeePopup.index && this.isEmployeePopup.index != -1 && data) {
            this.updateGridRow(this.isEmployeePopup.index, data)
            let obj = {
                rowData: this.grid?.gridData?.rowData[this.isEmployeePopup.index],
                columnData: this.grid?.gridData?.columnData[0],//employee
                columnKey: this.grid?.gridData?.columnData[0]?.columnCode
            }
            this.onRowUpdate(obj)
        }
        this.toggleVisibleEmp(null);
        this.updateState()
    }
    onMapToggle(data) {
        if (this.isLocationPopup.index && this.isLocationPopup.index != -1 && data) {
            this.updateGridRow(this.isLocationPopup.index, data,true)
            let obj = {
                rowData: this.grid?.gridData?.rowData[this.isLocationPopup.index],
                columnData: this.grid?.gridData?.columnData[this.isLocationPopup.index],
                columnKey: this.grid?.gridData?.columnData[this.isLocationPopup.index]?.columnCode
            }
            this.onRowUpdate(obj)
        }
        this.toggleVisibleMap(null);
        this.updateState()
    }
    onAddNewGeoLocationClose(data) {
        this.addNewGeoLocation.visible = false;
        if(data) {
            this.initial()
        }
        this.updateState()
    }
    renderForm() {
        return (
            <div className=" parent-width mt-l ">
                <div className="">
                    <div className="row">
                        <Toggle
                            className="border-n"
                            isOn={this.state.isLocationEnable}
                            onChange={() => {
                                this.onToggleChange();

                            }}
                        />
                        <DKLabel className="pl-l" text={i18next.t("GEO_FENCING_ALLOW")} />
                    </div>
                </div>
            </div>
        )
    }
    onContextCancel() {
        this.initial()
    }
    onRowClick(data) {
        console.log(data)
    }

    showFeedbackPopup = () => {
        this.setState({ needFeedbackPopup: true });
    };

    hideFeedbackPopup = () => {
      this.setState({ needFeedbackPopup: false });
    };

    getEmployeeMapGrid() {
        return (
            <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_ATTENDANCE_SETTING}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[{
                            title:  `+ ${i18next.t("ADD_MAPPING")}` ,
                            className: "bg-app text-white",
                            onClick: () => { this.onRowAdd() },
                        }]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                            this.selection = (selection);
                        }}
                        isActionEnabled={true}

                        allowBulkOperation={true}
                        dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            this.onContextCancel();
                        }}
                        contextMenu={false}
                        onRowClick={(data)=>{
                            this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            this.grid.gridActions.currentPage = requestedPageNumber
                            this.getAttendanceData()
                        }}
                        onSearch={(data)=>this.onSearch(data)}
                    />
                </div>
            </div>
        )
    }
    loadNoPlanActive() {
        return (
          <div className="parent-width parent-height d-flex align-items-center justify-content-center bg-gray1 mt-l border-m">
            <div>
              <DKIcon
                className="opacity-5 align-items-center d-flex parent-width ic-xl mb-l"
                src={DKIcons.ic_location}
              />
              <div className="row">
                <div className="column">
                  <DKLabel
                    className="mb-l text-align-center"
                    text={`${i18next.t("GEO_LOCATION_ADD_ON_SUBSCRIPTION")} `}
                  />
                </div>
                <div className="column" onClick={this.showFeedbackPopup}>
                  <DKLabel
                    className="mb-l text-align-center text-blue cursor-hand"
                    text="<u>care@deskera.com</u>"
                  />
                </div>
              </div>

              {/* <DKButton className="m-auto bg-app text-white w-fit-content " title={`${i18next.t("SUBSCRIBE_NOW")}`} onClick={()=>{window.open(process.env.REACT_APP_URL_GO + `billing`, "_blank");}}/> */}
            </div>
          </div>
        );
    }
    onSegmentSelect(segment, index) {
        if(segment.id == 1) {
            this.initial();
            this.getLocations();
        }
        this.setState({
            initialTabValue:segment.id
        })
    }
    tenantConfig() {
        const tenantConfig = TenantService.get(TENANT.CONFIG);
            if (!tenantConfig.confId) {
                CompanyDetailService.getTenantConfig().then(
                    (response) => {
                        if (response) {
                            TenantService.set(TENANT.CONFIG, response);
                            
                        }
                    }, (error) => {
                       
                    }
                );
            }
          }
    render() {
        return (
            <>
            {(this.isPlanLoaded.userPlan  && this.isPlanLoaded.geoFencing) && <>
                <div className="row justify-content-between">
                    <DKLabel className=" fs-r fw-m fs-l" text={i18next.t("GEO_FENCING_SETTING")} />
                </div>

                {this.state.isPROPlan && <div style={{
                                        pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                                        opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                                        }}> 
                    {this.renderForm()}
                        {(this.state.isLocationEnable) && <>
                            <SegmentListContainer
                                data={this.tabData}
                                selectedId={this.state.initialTabValue}
                                onChange={(segment, index)=>this.onSegmentSelect(segment, index)}

                                maxWidth={React.createRef().current?.innerWidth}
                                isAddEnabled={false}
                            />
                            {this.addNewGeoLocation.visible && <AddNewGeoFencingPopup geoLocations={this.geoLocations} onClose={(data => { this.onAddNewGeoLocationClose(data) })} />}
                            {this.isLocationPopup.visible && <MapPopup data={this.isLocationPopup.data} onClose={(data => { this.onMapToggle(data) })} />}

                            {this.isEmployeePopup.visible && <EmployeePopup data={this.isEmployeePopup.data} onClose={(data => { this.onEmployeeClose(data) })} />}
                            {this.state.initialTabValue === 1 && this.getEmployeeMapGrid()}
                            {this.state.initialTabValue === 0 && <LocationMapping/>}
                        </>}
                </div>
                }
                {!this.state.isPROPlan && this.loadNoPlanActive()}
                </>
                }{
                    !(this.isPlanLoaded.userPlan  && this.isPlanLoaded.geoFencing) &&
                     <div className="parent-width">
                         <DKSpinner className="pt-xxl pb-xxl mt-xxl" />
                    </div>
                }
                {this.state.needFeedbackPopup && (
                    <FeedbackPopup onCancel={this.hideFeedbackPopup} />
                )}
            </>
        )
    }
}
